import { useMutation } from '@tanstack/react-query'

import { GET_PLANTING_FAILURE_SUMMARY_FROM_DIAGNOSIS_QUERY } from '@/hooks/queries/use-get-planting-failure-summary-from-diagnosis'
import { createPlantingFailure } from '@/services/create-planting-failure'
import { GetPlantingFailureSummaryFromDiagnosisResponse } from '@/services/get-planting-failure-summary-from-diagnosis'
import { queryClient } from '@/services/query-client'

export const useCreatePlantingFailure = () => {
  const mutation = useMutation(
    ({ culture, demandId }: { culture: string; demandId: string }) =>
      createPlantingFailure(culture, demandId),
    {
      onSuccess(failures, variables) {
        const queryKey = [
          GET_PLANTING_FAILURE_SUMMARY_FROM_DIAGNOSIS_QUERY,
          variables.culture,
          variables.demandId,
        ]

        queryClient.setQueryData<GetPlantingFailureSummaryFromDiagnosisResponse>(
          queryKey,
          (oldData) => {
            if (!oldData) return undefined as any

            return {
              ...oldData,
              failures,
            }
          },
        )
      },
    },
  )

  return mutation
}
